import React from 'react';
import { NavLink } from 'react-router-dom';
import logoImg from '../logo.svg';
import { Icon } from 'react-icons-kit';
import { menu } from 'react-icons-kit/feather/menu';
import { arrowLeft } from 'react-icons-kit/feather/arrowLeft'
import { useParams, useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
import { useJwt } from "react-jwt";
import { EditProductCategory, GetCategoryById, GetCategoryImage, GetProductStatus, api_url, } from '../apiconfig/authService';
import { RiLoaderFill } from "react-icons/ri";
import { toast } from 'react-toastify';

function EditCategory(props) {
  const navigate = useNavigate();
  const { _, isExpired } = useJwt(localStorage.getItem('accessToken'));
  if (isExpired)
    navigate('/');

  const setCategoryViewMessage = props.setMessage;

  const [categoryData, setCategoryData] = useState({});
  const [editedCategoryData, setEditedCategoryData] = useState({});
  const { categoryid } = useParams();
  const [fetchCategoryData, setFetchCategoryData] = useState(false);
  const [newImage, setNewImage] = useState(null);
  const [statusData, setStatusData] = useState([]);
  const imageInputRef = React.createRef();
  const [loading, setLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);

  useEffect(() => {
    (
      async () => {
        setLoading(true);
        try {
          const response = await GetCategoryById(categoryid, localStorage.getItem('accessToken'));
          setLoading(false);
          setCategoryData(response.data.productCategory._doc);
          setEditedCategoryData(response.data.productCategory._doc);
        } catch (error) {
          console.log(error);
        } finally {
          setLoading(false);
        }
      }
    )();
  }, [fetchCategoryData]);

  useEffect(() => {
    (
      async () => {
        setLoading(true);
        try {
          const statusResponse = await GetProductStatus(localStorage.getItem('accessToken'));
          setLoading(false);
          setStatusData(statusResponse.data);
        } catch (error) {
          console.log(error);
        } finally {
          setLoading(false);
        }
      }
    )();
  }, []);

  const handleNameChange = (e) => {
    const temp = { ...editedCategoryData };
    temp.name = e.target.value;
    setEditedCategoryData(temp);
  };

  const handleImageChange = (e) => {
    setNewImage(e.target.files[0]);
  };

  const handleDiscardClick = async () => {
    if (imageInputRef.current) {
      imageInputRef.current.value = '';
    }
    setNewImage(null);
    const temp = { ...categoryData };
    setEditedCategoryData(temp);
    navigate("/category");
  };

  const handleStatusChange = (e) => {
    const temp = { ...editedCategoryData };
    temp.statusid = e.target.value;
    setEditedCategoryData(temp);
  };

  const handleSubmitClick = async (e) => {
    e.preventDefault();

    try {
      if (editedCategoryData.name === "") {
        toast.error("Category Name is required!");
        return;
      }
    } catch (error) {
      toast.error(error.message);
      window.scrollTo(0, 0);
      return;
    }

    let response;
    const formData = new FormData();
    formData.append('categoryid', editedCategoryData.categoryid);
    formData.append('name', editedCategoryData.name);
    formData.append('statusid', editedCategoryData.statusid);
    if (newImage) {
      formData.append('image', newImage);
      formData.append('imagename', editedCategoryData.image);
    }

    try {
      setEditLoading(true);
      response = await EditProductCategory(formData,localStorage.getItem('accessToken'));
      if (response.status === 200) {
        setEditLoading(false);
        toast.success("Category Updated Successfully");
        setCategoryViewMessage(response.data.message);
        navigate('/category');
      }
    } catch (err) {
      if ((err.response && err.response.data) && err.response.data.error) {
        setEditLoading(false);
        toast.error(err.response.data.error);
        window.scrollTo(0, 0);
      } else {
        toast.error('An error occurred. Please try again later.');
        window.scrollTo(0, 0);
      }
    } finally {
      setEditLoading(false);
    }

  };

  return (
    <div className="dashboard-content">
      <Sidebar />
      <div className="body-cart tab-content dasContent p-4 bg-white rounded">
        <div className="d-flex justify-content-between align-items-start pb-4 border-bottom mb-4">
          <h1 className="heading h4 mb-0 fw-bold">Edit Category</h1>
          <div className="d-inline-flex gap-2">
            <NavLink to="/category" className="btn btn-primary">
              View All
            </NavLink>
          </div>
        </div>
        {loading ? (
          <div className="d-flex align-items-center justify-content-center">
            <RiLoaderFill
              size={40}
              className="text-success spin-animation text-center"
            />
          </div>
        ) : (
          <div
            role="tabpanel"
            className="personal-info tab-pane active"
            id="pi"
          >
            {/* <h4 className="text-primary h6 fw-bold mb-3">Product main category information</h4> */}
            <div className="row">
              <div className="form-group col-sm-12 col-lg-6 mb-3">
                <div className="form-floating mb-4">
                  <input
                    type="text"
                    value={editedCategoryData?.name || ""}
                    onChange={handleNameChange}
                    className="form-control"
                    id="catName"
                    placeholder="Product Main Category Name"
                  />
                  <label htmlFor="catName">Name</label>
                </div>
                <div className="form-group col-sm-12 col-lg-6 mb-3">
                  <div className="form-floating mb-4">
                    <input
                      type="file"
                      ref={imageInputRef}
                      className="form-control"
                      id="catImg"
                      onChange={handleImageChange}
                      placeholder="Product Main Category Image"
                    />
                    <label htmlFor="catImg">Image</label>
                    <img
                      width="100px"
                      height="100px"
                      src={`${api_url}/product/category/getCategoryImage/${editedCategoryData?.image}`}
                    />
                  </div>
                </div>
                <div className="form-floating mb-4">
                  <select
                    className="form-select"
                    onChange={handleStatusChange}
                    value={editedCategoryData?.statusid}
                  >
                    {statusData?.map((item, index) => (
                      <option value={item.statusid} key={index}>
                        {item.status}
                      </option>
                    ))}
                  </select>
                  <label htmlFor="floatingInput">Status</label>
                </div>
              </div>
            </div>
            <div className="row">
              <div
                className="col-12 d-flex"
                style={{ height: "40px", width: "120px" }}
              >
                <button
                  type="submit"
                  disabled={editLoading}
                  onClick={handleDiscardClick}
                  style={{ height: "100%", width: "100%" }}
                  className="btn btn-danger save-btn text-uppercase"
                >
                  Discard
                </button>{" "}
                &nbsp;
                {editLoading ? (
                  <div
                    className="btn btn-primary loader-active save-btn"
                    style={{ height: "100%", width: "100%" }}
                  >
                    <RiLoaderFill
                      size={20}
                      className="spin-animation"
                      color="white"
                    />
                  </div>
                ) : (
                  <button
                    type="submit"
                    disabled={editLoading}
                    onClick={handleSubmitClick}
                    className="btn btn-primary save-btn text-uppercase"
                    style={{ height: "100%", width: "100%" }}
                  >
                    Save
                  </button>
                )}
              </div>
            </div>
          </div>
        )}
        <hr />
      </div>
    </div>
  );
}
export default EditCategory;
